export const setAppSettingsAction = (appSettings) => (
    {
        type: '_appSettings_Set',
        payload: appSettings  
    }
)